import { theme } from '../../styles/theme';
export const taxIncluded = {
    backgroundColor: theme.palette.common.feedbackSuccess10,
    padding: '2px 12px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '80px',
    height: '24px',
    gap: '4px',
    flexDirection: 'row'
};
export const taxIncludedText = {
    fontSize: '14px',
    color: theme.palette.common.feedbackSuccess50,
    lineHeight: 1
};
//# sourceMappingURL=TaxIncluded.styles.js.map